import store from '../store'
import {serverRequest} from './actionUtils'
import {Modal} from "../../data/data";
import {Action} from "../../data/ActionTypes";
import {URLS} from "../../data/urls";
import {RequestMethod} from "../../data/requestMethod";
import {showAlert} from "../actions";
import {AlertType} from "../../data/AlertType";

export function changeWriteOfState( data ) {
    return {
        type: Action.WriteOff.CHANGE_STATE,
        data
    }
}

export function resetWriteOf() {
    return {
        type: Action.WriteOff.RESET
    }
}

function getFilter() {
    const state = store.getState()
    return {
        created_at: state.writeof.filter_created_at,
        page: state.writeof.page
    }
}

export function getWriteOf(write_of_id) {

    const body = {id: write_of_id}
    const url = URLS.WriteOff.GET
    const error_message = 'Запрос Списаний не выполнен'

    return async dispatch => {

        const data = await serverRequest(body, url, dispatch, error_message)

        if (data.success) {
            dispatch({
                type: Action.WriteOff.EDIT,
                write_of: data.write_of,
            })
            dispatch({
                type: Action.Visible.CHANGE_STATE,
                data: {isCentralModalOpen: true, modalCentralType: Modal.Type.WRITE_OFF}
            })
        }

    }
}

export function addWriteOf () {

    const body = getFilter()
    const url = URLS.WriteOff.ADD
    const error_message = 'Запрос на создание Списания не выполнен'

    return async dispatch => {

        const data = await serverRequest(body, url, dispatch, error_message)

        if (data.success) {
            dispatch({
                type: Action.WriteOff.CHANGE_STATE,
                data: {write_offs: data.write_offs, count: data.count},
            })
        }
    }
}

export function createWriteOf() {

    const state = store.getState()

    const parts = state.writeof.parts.filter(part => !state.writeof.inventory_id || part.checked)

    const body = {
        engineer_id: state.writeof.engineer.id,
        discount_margin_id: state.writeof.discount_margin.id,
        write_of_type: state.writeof.write_of_type,
        parts,
        description: state.writeof.description,
        inventory_id: state.writeof.inventory_id || null,
        warehouse_id: state.remain.filter_warehouse.id,
        filter: getFilter()
    }
    const url = URLS.WriteOff.POST
    const error_message = 'Запрос на создание Списания не выполнен'

    return async dispatch => {

        const data = await serverRequest(body, url, dispatch, error_message)

        if (data.success) {
            if (state.writeof.write_of_type.type === 'WAREHOUSE') {
                dispatch({
                    type: Action.WriteOff.CHANGE_STATE,
                    data: {write_offs: data.write_offs, count: data.count},
                })
            }
            if (state.writeof.write_of_type.type === 'ORDER') {
                dispatch({
                    type: Action.Order.EDIT,
                    order: data.order
                })
                dispatch({
                    type: Action.Order.CHANGE_STATE,
                    data: {events: data.events || []},
                })
            }
            if (state.inventory.edit) {
                dispatch({
                    type: Action.Inventory.EDIT,
                    inventory: data.inventory
                })
            }
            dispatch({
                type: Action.WriteOff.RESET
            })
            dispatch({
                type: Action.Visible.CHANGE_STATE,
                data: {isCentralModalOpen: false, modalCentralType: ''}
            })
            showAlert(dispatch, AlertType.SUCCESSES, 'Списание успешно создано')
        }
    }
}

export function saveWriteOf() {

    const state = store.getState()

    const body = {
        id: state.writeof.edit,
        description: state.writeof.description,
        filter: getFilter()
    }
    const url = URLS.WriteOff.POST
    const method = RequestMethod.PUT
    const error_message = 'Запрос на изменение Списания не выполнен'

    return async dispatch => {

        const data = await serverRequest(body, url, dispatch, error_message, method)

        if (data.success) {
            dispatch({
                type: Action.WriteOff.CHANGE_STATE,
                data: {write_offs: data.write_offs, count: data.count},
            })
            dispatch({
                type: Action.WriteOff.RESET
            })
            dispatch({
                type: Action.Visible.CHANGE_STATE,
                data: {isCentralModalOpen: false, modalCentralType: ''}
            })
            showAlert(dispatch, AlertType.SUCCESSES, 'Списание успешно изменено')
        }
    }
}

